<template lang="pug">
  div
    router-link(:to="{ name: properties.link }" active-class="header-router-link-active" ref="primaryLink")
      v-list-tile
        v-list-tile-action
          v-icon(color="black") {{ properties.icon }}
        v-list-tile-content.tile(v-if="!properties.items")
          span {{ properties.name }}
        v-list-tile-content.tile(v-else)
          v-list-tile-title {{ properties.name }}
            v-icon(@click="expand").float-right {{ getIcon }}
    router-link.sub-tile(v-if="properties.items"
                        v-for="sub in properties.items"
                        :to="{ name: properties.link, hash: sub.hash }"
                        active-class="header-router-sublink-active"
                        ref="sublinks"
                        @click.native="scrollToId(sub.hash)")
        v-list-tile(v-show="isExpanded")
          v-list-tile-title.tile {{ sub.name }}
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    properties: Object,
  },
  data() {
    return {
      isExpanded: this.properties.expanded,
    }
  },
  mounted(){
    if(this.$refs.sublinks) {
      this.$refs.sublinks.forEach( item => {
          if(item.$el.classList.contains('header-router-sublink-active')) {
            this.$refs.primaryLink.$el.classList.remove("header-router-link-active");
          }
      });
    }
  },
  methods: {
    expand() {
      this.isExpanded = !this.isExpanded;
    },
    scrollToId(id) {
      setTimeout(() => {
        let anchors = document.querySelectorAll('#account-mgmt-content a')
        anchors.forEach(e => {
          var element = e;
          if(e.href.includes(id)){
            var headerOffset = 135;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
          }
        });
        this.$refs.primaryLink.$el.classList.remove("header-router-link-active");
      }, 250);

    }
  },
  computed: {
    getIcon() {
      return this.isExpanded ? 'expand_less' : 'expand_more';
    }
  },
};
</script>
<style lang="scss" scoped>
.tile {
  color: black;
  margin-left: -10px;
  font-size: 14px !important;
  width: 100%;
}

.sub-tile {
  color: black;
  height: 25px;

  .v-list__tile__title {
    font-size: 14px;
  }

  div[role="listitem"] {
    height: 40px;
    width: 100%;

    .v-list__tile__title {
      margin-left: 50px !important;
    }
  }
}

.router-link,
.header-router-link-active {
  color: black;

  div[role="listitem"] {
    background: #ccc;
  }

  .tile {
    font-weight: bold;
  }
}

.router-link,
.header-router-sublink-active {
  color: black;

  div[role="listitem"] {
    background: #ccc;
  }

  .tile {
    font-weight: bold;
  }
}

</style>
